// CK lô (%) — quy ước: "không đánh dấu" và 0 là cùng một trạng thái.
//
// DB lưu `product_lots.discount_percent NUMERIC(5,2) NOT NULL DEFAULT 0`, và
// FIFO coi `discount_percent = 0` là lô trung tính (xem
// product_lot_repository.go FIFOPickLots). Nên bỏ trống ô CK và gõ 0 phải cho
// ra cùng một kết quả: không gửi field, để BE ghi 0.

/** Số chữ số thập phân DB giữ được — NUMERIC(5,2). */
const SCALE = 2
const FACTOR = 10 ** SCALE

/** Làm tròn nửa lên như Postgres. Cộng epsilon tỉ lệ theo |v| để bù sai số nhị
 *  phân: 12.345 * 100 ra 1234.4999999999998 nên Math.round trần trụi sẽ ra
 *  12.34, lệch với giá trị Postgres thực sự lưu. */
function roundToScale(value: number): number {
    const corrected = value + Number.EPSILON * Math.abs(value)
    return Math.round(corrected * FACTOR) / FACTOR
}

/** Đọc giá trị thô từ `<input type="number">` thành giá trị form.
 *
 *  Dùng thay cho `valueAsNumber` của react-hook-form: `valueAsNumber` biến ô
 *  rỗng thành NaN, mà `z.number().optional()` từ chối NaN — khiến ô CK vốn tuỳ
 *  chọn lại chặn submit. Trả về `undefined` cho mọi input không phải số.
 *
 *  Giữ nguyên độ chính xác người dùng gõ để `.min`/`.max` vẫn soi được giá trị
 *  thật; việc làm tròn theo scale của DB để cho `normalizeLotDiscount`. */
export function parseLotDiscountInput(raw: unknown): number | undefined {
    if (typeof raw === 'number') {
        return Number.isFinite(raw) ? raw : undefined
    }
    if (typeof raw !== 'string') return undefined

    const trimmed = raw.trim()
    if (trimmed === '') return undefined

    const parsed = Number(trimmed)
    return Number.isFinite(parsed) ? parsed : undefined
}

/** Chuẩn hoá CK lô trước khi gửi API.
 *
 *  Làm tròn về scale của DB để giá trị gửi đi đúng bằng giá trị Postgres lưu —
 *  quan trọng vì FIFO so khớp mức CK bằng `=`. Trả `undefined` khi không có
 *  giá trị hoặc khi kết quả là 0, để phiếu không ghi mức CK nào cả. */
export function normalizeLotDiscount(
    value: number | undefined,
): number | undefined {
    if (value === undefined || !Number.isFinite(value)) return undefined

    const rounded = roundToScale(value)
    return rounded === 0 ? undefined : rounded
}
